import React from "react";
import { useSearchParams } from "react-router-dom";

const AgeRangeFilter = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    // Parse the "age" query parameter from the URL
    const minAge = searchParams.get('minAge') ? searchParams.get('minAge') : 0;
    const maxAge = searchParams.get('maxAge') ? searchParams.get('maxAge') : 50;

    const handleMinAgeChange = (e) => {
        searchParams.set('minAge', parseInt(e.target.value));
        setSearchParams(searchParams);
    };
    const handleMaxAgeChange = (e) => {
        searchParams.set('maxAge', parseInt(e.target.value));
        setSearchParams(searchParams);
    };

    return (
        <div className='category-container'>
            <h2 className='text-lg text-primary font-semibold'>Shop By Age :</h2>
            <hr/>
            <div className="d-flex">
                <div className="wrapper">
                    <div className="price-input">
                        <div className="field">
                            <span>Min: {minAge}</span>
                        </div>
                        <div className="separator">-</div>
                        <div className="field">
                            <span>Max: {maxAge}</span>
                        </div>
                    </div>
                    <div className="slider">
                        <div
                            className="progress"
                            style={{
                                left: `${(minAge / 50) * 100}%`,
                                right: `${100 - (maxAge / 50) * 100}%`,
                            }}
                        ></div>
                    </div>
                    <div className="range-input">
                        <input
                            type="range"
                            className="range-min"
                            min="0"
                            max="50"
                            value={minAge}
                            step="1"
                            onChange={handleMinAgeChange}
                        />
                        <input
                            type="range"
                            className="range-max"
                            min="0"
                            max="50"
                            value={maxAge}
                            step="1"
                            onChange={handleMaxAgeChange}
                        />
                    </div>
                </div>
            </div>
        </div>

    );
};

export default AgeRangeFilter;
